// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"HighImpact_cardContainer__T4Ha1","cardTitle":"HighImpact_cardTitle__So0DW","tagline":"HighImpact_tagline__Af2or","animationSlot":"HighImpact_animationSlot__Rk9fc"};